import React from 'react';

/** Mirrors `INVOICE_NOTE_MAX_LENGTH` in new-backend/admin/src/lib/invoicing/invoiceNote.ts. */
export const INVOICE_NOTE_MAX_LENGTH = 1000;

/**
 * The optional free-text note printed on an invoice or a Storno — e.g. the date
 * payment was received, or the account a refund goes to.
 */
const InvoiceNoteField = ({
    id, label, hint, value, disabled = false, onChange,
}: Readonly<{
    id: string;
    label: string;
    hint: string;
    value: string;
    disabled?: boolean;
    onChange: (value: string) => void;
}>) => (
    <div className={'mb-3'}>
        <label className={'block text-sm text-foreground/60 mb-1'} htmlFor={id}>
            {label}
        </label>
        <textarea
            id={id}
            value={value}
            rows={3}
            maxLength={INVOICE_NOTE_MAX_LENGTH}
            disabled={disabled}
            onChange={(e) => onChange(e.target.value)}
            className={'w-full border border-foreground/20 rounded-[5px] px-3 py-2 text-sm mb-1'}
        />
        <p className={'text-xs text-foreground/60'}>{hint}</p>
    </div>
);

export default InvoiceNoteField;
